























































import { defineComponent, onMounted, ref } from "@vue/composition-api";
import Navigation from "./components/Navigation.vue";
import PestCard from "./components/PestCard.vue";

import router from "@/router/index";
import { getPestList, IResPest } from "@/api/diseasePest";
import { goBack } from "@/utils/goBack";

export type ListDataType = {
  infoList: IResPest[];
  refreshing: boolean;
  finished: boolean;
  loading: boolean;
  page: number;
  size: number;
};
export default defineComponent({
  components: {
    Navigation,
    PestCard,
  },
  setup() {
    const pageTitle = ref("");
    const finishSearch = ref(false);
    const activeTab = ref(1);
    const cid = ref(0);
    const scrollListRef = ref<HTMLDivElement | null>(null);
    cid.value = (router.currentRoute.query.cid as unknown) as number;
    pageTitle.value = router.currentRoute.query.title as string;

    const listData = ref<ListDataType>({
      infoList: [],
      refreshing: false,
      finished: false,
      loading: false,
      page: 1,
      size: 20,
    });

    const handleStart = async (type?: number) => {
      const param = {
        status: 1,
        type: type != undefined ? type : activeTab.value,
        cropId: cid.value,
        page: listData.value.page,
        size: listData.value.size,
      };
      const [err, data] = await getPestList(param);
      if (!err && data != null && data.data != null) {
        if (param.page > 1) {
          //加载多页
          listData.value.infoList = listData.value.infoList.concat(data.data);
        } else {
          //加载更新
          listData.value.infoList = data.data;
        }

        if (param.page < data.maxPageNumber) {
          listData.value.finished = false;
          listData.value.page = listData.value.page + 1;
        } else {
          //更换分类
          listData.value.finished = true;
          listData.value.page = 1;
        }
      }
      if (listData.value.refreshing) {
        listData.value.refreshing = false;
      }
      setTimeout(() => {
        listData.value.loading = false;
        finishSearch.value = true;
      }, 200);
    };

    //下拉刷新
    const handleRefresh = () => {
      listData.value.page = 1;
      listData.value.finished = false;
      listData.value.loading = true;
      finishSearch.value = false;
      handleStart();
    };

    onMounted(() => {
      handleStart();
    });
    const onClickTab = (value: number) => {
      listData.value.page = 1;
      listData.value.finished = false;
      finishSearch.value = false;
      handleStart(value);
      if (scrollListRef.value != null) {
        scrollListRef.value.scrollTop = 0;
      }
    };

    return {
      handleBack: () => {
        goBack();
      },
      pageTitle,
      finishSearch,
      activeTab,
      onClickTab,
      listData,
      handleRefresh,
      scrollListRef,
      handleStart,
      handleToDetail: (cid: number) => {
        router.push({
          path: "/pest/pestDetail",
          query: { id: (cid as unknown) as string, no_back_app: "1" },
        });
      },
    };
  },
});
